import ApiManager from "@/code/api-manager";

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = nuxtApp.$config;
  console.log("runtimeConfig", runtimeConfig);
  console.log("runtimeConfig.apiBase", runtimeConfig.apiBase);
  console.log("runtimeConfig.public.apiBase", runtimeConfig.public.apiBase);
  const apiManager = ApiManager.getInstance(runtimeConfig);

  // Provide the apiManager instance to the Nuxt app
  nuxtApp.provide("apiManager", apiManager);
});
